import { Typography } from "@mui/material";
import { ReactNode } from "react";

interface SectionHeadingProps {
  id: string;
  children: ReactNode;
}

export const SectionHeading = ({ id, children }: SectionHeadingProps) => (
  <Typography
    id={id}
    component="h2"
    sx={{ fontSize: 16, fontWeight: 600, lineHeight: 1.3, mb: 1.5 }}
  >
    {children}
  </Typography>
);
